import {isBrowser} from 'helpers/isBrowser';

export const getCookie = (name) => {
	if (!isBrowser()) return;
	const escapedName = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
	const regex = new RegExp(`(?:^|; )${escapedName}=([^;]*)`, 'g');
	const cookies = document.cookie;
	let lastMatch = null;
	let match;

	match = regex.exec(cookies);
	while (match !== null) {
		lastMatch = match[1];
		match = regex.exec(cookies);
	}

	return lastMatch ? decodeURIComponent(lastMatch) : undefined;
};
